import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { getFormattedTimezone } from '../../utils';

@Pipe({
  name: 'rtFormatTimezone',
  standalone: true,
})
export class FormatTimezonePipe implements PipeTransform {
  public transform = getFormattedTimezone;
}
